export default __webpack_public_path__ + "static/media/twitter1.5a55ec8c.png";